export const CONSENT_CHANNEL_IN_APP = 'IN_APP';

export const CONSENT_SOURCE_SYSTEM_ONBOARDING = 'onboarding';
export const CONSENT_SOURCE_SYSTEM_TAX = 'tax';
export const CONSENT_SOURCE_SYSTEM_REFERRALS = 'referrals';

export const CONSENT_SOURCE_LOCATION_ACTIVATE_MEMBER = 'activate-member';
export const CONSENT_SOURCE_LOCATION_GET_PERSONAL_INFO = 'get-personal-info';
export const CONSENT_SOURCE_LOCATION_TAX_ORGANIZER = 'tax_organizer';
export const CONSENT_SOURCE_LOCATION_ITR_RECONSENT = 'itr_reconsent_modal';
export const CONSENT_SOURCE_LOCATION_REFER_AND_EARN_CONNECT_CONTACTS = 'refer_and_earn_connect_contacts';

/**
 * The standalone tax-return consent document. Registered above the member shell so it renders
 * without the sidebar and header -- it is a legal document opened in its own tab, not an app screen.
 */
export const TAX_RETURN_CONSENT_PATH = '/tax/consent';

/**
 * The backend rejects a consent grant when the signed name doesn't match the member's legal
 * tax-payer name; it responds with `error_type: "invalid_signature"`. Shared by every surface that
 * takes a typed signature -- the ITR organizer's AcceptTerms step and the re-consent modal.
 */
export const INVALID_SIGNATURE_ERROR_TYPE = 'invalid_signature';
export const SIGNATURE_MISMATCH_ERROR = 'The name you signed must match your legal name';

/** Which section of the document a link lands on. */
export type ConsentAnchor = 'use' | 'disclose';

export const CONSENT_ANCHOR_HASHES: Record<ConsentAnchor, string> = {
    use: 'consent-to-use',
    disclose: 'consent-to-disclose',
};

/**
 * URL for the consent document, optionally deep-linked to a section.
 *
 * Without an anchor the page opens at the top -- which is where "Consent to Use" already is, so
 * that link does not need one.
 */
export const taxReturnConsentUrl = (anchor?: ConsentAnchor) =>
    anchor ? `${TAX_RETURN_CONSENT_PATH}#${CONSENT_ANCHOR_HASHES[anchor]}` : TAX_RETURN_CONSENT_PATH;
